// extracted by mini-css-extract-plugin
export default {"tooltip":"oA-z","arrow":"pA-z"};